import { LayoutModule } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DraftFacade } from '@classifieds-sell/state';
import { TrademeCoreUiModule } from '@classifieds-sell/trademe-core-ui';
import {
    TgCheckboxModule,
    TgDateTimeFormatterModule,
    TgFormGroupModule,
    TgGridModule,
    TgIconBasicArrowRightModule,
    TgIconBasicTickFramedModule,
    TgIconStopModule,
    TgInputModule,
    TgRackModule,
    TgRadioModule,
    TgSelectModule,
    TgInfoBoxModule
} from '@trademe/tangram';
import { DraftValidationModule, WholeNumberDirectiveModule } from '@classifieds-sell/shared';
import { TmDateComponent } from 'libs/trademe-core-ui/src/lib/tm-date/tm-date.component';
import { MotorsAuctionPricingSectionComponent } from './motors-auction-pricing-section.component';
import { MotorsEndingDateTimeSectionComponent } from './motors-ending-datetime-section.component';
import { MotorsAcceptedPaymentsSectionComponent } from './motors-accepted-payments-section.component';
import { MotorsVehicleTransferOptionsSectionComponent } from './motors-vehicle-transfer-options-section.component';
import { MotorsClassifiedPricingSectionComponent } from './motors-classified-pricing-section.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TgIconBasicArrowRightModule,
        TgIconStopModule,
        TgIconBasicTickFramedModule,
        TgGridModule,
        TgSelectModule,
        TgInputModule,
        TgRackModule,
        TgRadioModule,
        TgFormGroupModule,
        LayoutModule,
        TrademeCoreUiModule,
        DraftValidationModule,
        TgDateTimeFormatterModule,
        TgCheckboxModule,
        WholeNumberDirectiveModule,
        TgInfoBoxModule
    ],
    declarations: [
        MotorsAuctionPricingSectionComponent,
        MotorsEndingDateTimeSectionComponent,
        MotorsAcceptedPaymentsSectionComponent,
        MotorsVehicleTransferOptionsSectionComponent,
        MotorsClassifiedPricingSectionComponent
    ],
    providers: [TmDateComponent, DraftFacade],
    exports: [
        MotorsAuctionPricingSectionComponent,
        MotorsEndingDateTimeSectionComponent,
        MotorsAcceptedPaymentsSectionComponent,
        MotorsVehicleTransferOptionsSectionComponent,
        MotorsClassifiedPricingSectionComponent
    ]
})
export class MotorsListingDetailsSectionModule {}